import React, { useContext } from "react";
import Typical from "react-typical";
import avatar from "../Assets/1A.svg";
import { Grid, Avatar } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import CAShield from "../Assets/CAShield.png";

import "../CSS/Mainpage.css";

import { AppContext } from "./Context.js";

export default function MainPage({ id }) {
  const [itemSnapped] = useContext(AppContext);
  return (
    <div
      className={itemSnapped === "MainPage" ? "vanish" : "mainpageDiv"}
      id={id}
    >
      <Grid container spacing={0}>
        <Grid item md={6} sm={6} xs={12}>
          <div style={{ paddingTop: "3vw" }}>
            <h1 className="customH1">Hi There!👋🏻 I'm </h1>
            <h1>
              <span className="customFName">Mohamed </span>
              <Typical
                steps={[2000, "Salah"]}
                wrapper="span"
                className="customLName"
              ></Typical>

              <p>
                <span className="customH1">Im a </span>
                <span className="customFName"> Software </span>
                <Typical
                  style={{ color: "red" }}
                  steps={["Engineer", 2000]}
                  wrapper="span"
                  className="customLName"
                ></Typical>
              </p>
            </h1>
          </div>
        </Grid>
        <Grid
          item
          md={6}
          sm={6}
          xs={12}
          style={{ textAlign: "-webkit-center" }}
        >
          <Avatar
            alt=""
            src={avatar}
            style={{
              width: 250,
              height: 250,
              backgroundColor: "#225599",
              marginTop: "10px",
              zIndex: "",
            }}
          />
        </Grid>
        <Grid
          item
          md={12}
          sm={12}
          xs={12}
          style={{ textAlign: "-webkit-center" }}
        >
          <div style={{ width: "90%" }} className="boxBorder">
            <p className="descr">
              A Software
              <span style={{ color: "#d10100" }}> Engineer </span>
              with a passion for learning new technologies. Always Excited for
              development.
            </p>
            <p className="descr">"I can do this all day" </p>
            <img
              src={CAShield}
              alt=""
              style={{
                width: 50,
                height: 50,
              }}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
